export default __webpack_public_path__ + "static/media/img (2).30a76da1.jpg";